export const SET_REQUESTALL_INDEX_DISP = 'SET_REQUESTALL_INDEX_DISP'
export const GET_REQUESTALL_INDEX_DISP = 'GET_REQUESTALL_INDEX_DISP'
export const SET_REQUESTALL_COLUMNS = 'SET_REQUESTALL_COLUMNS'
export const GET_REQUESTALL_COLUMNS = 'GET_REQUESTALL_COLUMNS'
export const SET_REQUESTALL_LABELS = 'SET_REQUESTALL_LABELS'
export const GET_REQUESTALL_LABELS = 'GET_REQUESTALL_LABELS'
export const RECEIVED_REQUESTALL_COLUMNS_LABELS = 'RECEIVED_REQUESTALL_COLUMNS_LABELS'
export const SET_REQUESTALL_INDEX = 'SET_REQUESTALL_INDEX'
export const GET_REQUESTALL_INDEX = 'GET_REQUESTALL_INDEX'
export const RECEIVED_REQUESTALL_INDEX = 'RECEIVED_REQUESTALL_INDEX'
export const SET_REQUESTALL_INDEX_SELECTED = 'SET_REQUESTALL_INDEX_SELECTED'
export const GET_REQUESTALL_INDEX_SELECTED = 'GET_REQUESTALL_INDEX_SELECTED'
export const TOGGLE_REQUESTALL_PAGE = 'TOGGLE_REQUESTALL_PAGE'

export const SET_REQUESTALL_DROPDOWNS = 'SET_REQUESTALL_DROPDOWNS'
export const GET_REQUESTALL_DROPDOWNS = 'GET_REQUESTALL_DROPDOWNS'
export const RECEIVED_REQUESTALL_DROPDOWNS = 'RECEIVED_REQUESTALL_DROPDOWNS'



// WEBPACK FOOTER //
// ./src/store/modules/requestall/mutation-types.js